import { render, staticRenderFns } from "./ContactsCoTable.vue?vue&type=template&id=8d0463ac&scoped=true"
import script from "./ContactsCoTable.vue?vue&type=script&lang=js"
export * from "./ContactsCoTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d0463ac",
  null
  
)

export default component.exports